import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Plugin } from 'ckeditor5/src/core.js';
import { getListTypeFromListStyleType as _getListTypeFromListStyleType, getSelectedListItems as _getSelectedListItems, getSiblingNodes as _getSiblingNodes } from './legacyutils.js';
/**
 * A set of helpers related to legacy lists.
 */
var LegacyListUtils = /*#__PURE__*/function (_Plugin) {
  _inherits(LegacyListUtils, _Plugin);
  var _super = _createSuper(LegacyListUtils);
  function LegacyListUtils() {
    _classCallCheck(this, LegacyListUtils);
    return _super.apply(this, arguments);
  }
  _createClass(LegacyListUtils, [{
    key: "getListTypeFromListStyleType",
    value:
    /**
     * Checks whether the given list-style-type is supported by numbered or bulleted list.
     */
    function getListTypeFromListStyleType(listStyleType) {
      return _getListTypeFromListStyleType(listStyleType);
    }
    /**
     * Returns an array with all `listItem` elements in the model selection.
     *
     * It returns all the items even if only a part of the list is selected, including items that belong to nested lists.
     * If no list is selected, it returns an empty array.
     * The order of the elements is not specified.
     */
  }, {
    key: "getSelectedListItems",
    value: function getSelectedListItems(model) {
      return _getSelectedListItems(model);
    }
    /**
     * Returns an array with all `listItem` elements that represent the same list.
     *
     * It means that values of `listIndent`, `listType`, `listStyle`, `listReversed` and `listStart` for all items are equal.
     *
     * Additionally, if the `position` is inside a list item, that list item will be returned as well.
     *
     * @param position Starting position.
     * @param direction Walking direction.
     */
  }, {
    key: "getSiblingNodes",
    value: function getSiblingNodes(position, direction) {
      return _getSiblingNodes(position, direction);
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'LegacyListUtils';
    }
  }]);
  return LegacyListUtils;
}(Plugin);
export { LegacyListUtils as default };